/**
* Represents a single operation in an SVG path
* @param {string} type 
* @param {number[]} values 
*/

export default class PathDataPoint {
  private _type : string;
  private _values : number [];

  constructor(type : string, values : number []){
    this._type = type;
    this._values = values;
  }

  get type() : string {
    return this._type;
  }

  get values() : number [] {
    return this._values;
  }
}